import { Modal } from "@/components/elements/Modal";
import { Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

type TConfirmDeleteModalProps = {
  message: ReactNode;
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  title?: string;
  hiddenOkBtn?: boolean;
  labelClose?: string;
  justifyBtnAction?: "center" | "space-between";
};

export const ConfirmDeleteModal: FC<TConfirmDeleteModalProps> = ({ open, onClose, onOk, message, title = "削除の確認", hiddenOkBtn, labelClose = "いいえ", justifyBtnAction }) => {
  return (
    <Modal isOpen={open} onClose={onClose} onOk={onOk} labelClose={labelClose} labelOk="はい" width={500} title={title} hiddenOkBtn={hiddenOkBtn} justifyBtnAction={justifyBtnAction}>
      <Stack mb={2}>
        <Typography component="div">{message}</Typography>
      </Stack>
    </Modal>
  );
};
